import FeedbackRes from "./FeedbackRes";
import ViewMoreFeedback from "./ViewMoreFeedback";

export {
    FeedbackRes,
    ViewMoreFeedback,
}